export default "__VITE_ASSET__DackFJJ___"